<template>
  <div
    id="userPreviewDetails"
    class="rm-scrollbar"
    style="width: 580px; line-height: normal"
  >
    <div class="flex-mid relative pt-35">
      <div style="position: absolute; top: 0px; left: 0px">
        <div
          v-if="userDetail.house && userDetail.house == '-LWPrZbcyHAVHIFUsWLd'"
        >
          <img class="house-seal-image" :src="getImgUrlMem('banner_corvus')" />
        </div>
        <div
          v-else-if="
            userDetail.house && userDetail.house == '-LWPrOElCYViBd6j6qP-'
          "
        >
          <img class="house-seal-image" :src="getImgUrlMem('banner_leonos')" />
        </div>
        <div
          v-else-if="
            userDetail.house && userDetail.house == '-LWOr-XsbZM2digYl1QL'
          "
        >
          <img
            class="house-seal-image"
            :src="getImgUrlMem('banner_delphinus')"
          />
        </div>
        <div v-else>
          <p class="houseSeal_1"></p>
          <p class="houseSeal_2"></p>
        </div>
      </div>
      <div v-if="userDetail.large_pic"
      :class="[ blurMode ?  'mega_blurelement': '' ]"
      >
        <img
          v-lazy="userDetail.large_pic"
          :key="userDetail.large_pic"
          style="object-fit: cover"
          class="image-skeleton image-profile-180 flex-mid"
          :class="[ blurMode ?  'mega_blurelement': '' ]"
        />
      </div>
      <div v-else class="image image-profile-180 flex-mid"
      :class="[ blurMode ?  'mega_blurelement': '' ]">
        <div class="text-in-image text-in-image-180 flex-mid">
          {{
            $utils("acronymName", {
              firstName: userDetail.firstname,
              lastName: userDetail.lastname,
            })
          }}
        </div>
      </div>
      <div style="position: absolute; top: 0px; right: 0px">
        <div class="divCoin">
          <div
            style="
              padding-left: 8px;
              padding-bottom: 5px;
              display: flex;
              align-items: center;
            "
          >
            <img
              class="iconCoin"
              :src="$utils('icons', 'ic_profile_coin')"
              alt=""
            />
            <span class="txtCoin"
              >{{ $utils("addCommasInNumber", userDetail.coin || 0) }}
              {{ $t("members.coins") }}</span
            >
          </div>
          <div style="padding-left: 8px; display: flex; align-items: center">
            <img
              class="iconCoin"
              :src="$utils('icons', 'ic_profile_gem')"
              alt=""
            />
            <span class="txtCoin"
              >{{ $utils("addCommasInNumber", userDetail.gem || 0) }}
              {{ $t("members.gems") }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="flex-mid" style="padding-top: 10px">
      <span
        v-if="userDetail.firstname || userDetail.lastname"
        class="txtProfileName"
        :class="[ blurMode ?  'mega_blurelement': '' ]"
        >{{ userDetail.firstname + " " + userDetail.lastname }}</span
      >
      <div v-else class="nullprofileName"></div>
    </div>

    <div class="flex-mid mt-2">
      <span v-if="userDetail.dispteam" class="txtProfileTeamName"
      :class="[ blurMode ?  'mega_blurelement': '' ]">{{
        userDetail.dispteam
      }}</span>
      <div v-else class="nullprofileTeamName"></div>
    </div>

    <div v-if="userDetail['joined']" class="center mt-8">
      <div class="flex-mid">
        <el-tooltip effect="dark" placement="top">
          <div class="fs-11 mx-13" slot="content">
            {{ userDetail.joined_tooltips["year"] }}
            {{ $t("commponents.years") }},
            {{ userDetail.joined_tooltips["month"] }}
            {{ $t("commponents.months") }},
            {{ userDetail.joined_tooltips["day"] }}
            {{ $t("commponents.days_ago") }} ●
            {{ userDetail.joined_tooltips["percent"] }}%
            {{ $t("commponents.joined_after") }}
          </div>
          <div style="color: #2d2e36; font-weight: 300" class="flex">
            <img
              :src="$utils('icons', 'date_gray_12')"
              alt="icons_date_gray_12"
              style="width: 12px; height: 12px"
              class="mt-3 mr-4"
            />
            <div class="pb-2">
              {{ $t("commponents.joined") }} {{ userDetail["joined"] }}
            </div>
          </div>
        </el-tooltip>
      </div>
    </div>

    <div class="flex-mid mt-8">
      <div class="div-active">
        <div class="btn-status" :class="[`status-${userDetail.status}`]">
          {{ userDetail.status }}
        </div>
        <div class="active">
          {{ userDetail.to_now ? userDetail.to_now : "&nbsp;" }}
        </div>
      </div>
    </div>

    <div v-if="userDetail.introduce" class="max-width-mobile mx-auto fc-000000">
      <div class="fs-14 fw-700 ml-18">About me</div>
      <div class="about-me-container"
      :class="[ blurMode ?  'blurelement': '' ]">{{ userDetail.introduce }}</div>
    </div>

    <div class="mx-auto">
      <div
        v-if="userDetail.introduce"
        class="max-width-mobile mx-auto fc-000000"
      >
        <div class="fs-14 fw-700 ml-18">Activity Timeline</div>
      </div>
      <div
        v-if="
          (modalMemberData['from'] &&
            modalMemberData['from'] == 'members' &&
            riskDataMembers) ||
          riskData
        "
        class="risk-container flex-center"
      >
        <div
          @click="loadMoreData"
          style="width: 32px"
          class="back-button flex-mid fs-16 cursor-pointer"
        >
          <i
            v-if="
              (modalMemberData['from'] &&
                modalMemberData['from'] == 'members' &&
                !loadingLoadMoreDataMembers) ||
              (!modalMemberData['from'] && !loadingLoadMoreData)
            "
            class="el-icon-arrow-left"
          ></i>
          <i v-else class="el-icon-loading"></i>
        </div>
        <div
          v-dragscroll
          id="riskBox"
          class="flex-center thin-scrollbar risk-box-grab cursor-grab"
        >
          <div
            v-for="(risk, index) in modalMemberData['from'] &&
            modalMemberData['from'] == 'members' &&
            riskDataMembers
              ? riskDataMembers
              : riskData"
            :key="'risk_data_' + index"
          >
            <div v-if="risk.day == 'Sat'" class="risk-line-breaking">
              &nbsp;
            </div>
            <div :class="`risk-status ${risk.status} flex-mid`">
              <div class="relative" v-if="risk.status">
                <div
                  v-if="
                    risk.highlight == 'S' ||
                    risk.highlight == 'S&R' ||
                    risk.highlight == 'S&2R' ||
                    risk.highlight == 'S&3R'
                  "
                  class="highlight"
                >
                  <div
                    v-if="
                      risk.highlight == 'S&R' ||
                      risk.highlight == 'S&2R' ||
                      risk.highlight == 'S&3R'
                    "
                    :class="`pop-up-red ${
                      risk.highlight == 'S&R'
                        ? 'red-1'
                        : risk.highlight == 'S&2R'
                        ? 'red-2'
                        : 'red-3'
                    }`"
                  >
                    <div
                      class="ml-auto cursor-pointer"
                      :style="`width: ${
                        risk.highlight == 'S&R'
                          ? '4'
                          : risk.highlight == 'S&2R'
                          ? '7'
                          : '10'
                      }px;`"
                    >
                      <el-tooltip placement="top">
                        <div slot="content" class="fw-400 fs-11" v-html="risk.highlightContent"></div>
                        <div class="fw-700 fs-12">
                          {{
                            risk.highlight == "S&R"
                              ? "!"
                              : risk.highlight == "S&2R"
                              ? "!!"
                              : "!!!"
                          }}
                        </div>
                      </el-tooltip>
                    </div>
                  </div>
                  <div class="pop-up flex-mid">
                    <el-tooltip placement="top">
                      <div slot="content" class="fw-400 fs-11">
                        Star performance from being in the top 15% of people who received recognition that week
                      </div>
                      <img
                        style="width: 12px; height: 12px"
                        :src="$utils('icons', 'ic_star_24px')"
                        alt=""
                      />
                    </el-tooltip>
                  </div>
                </div>
                <div
                  v-else-if="
                    risk.highlight == 'R' ||
                    risk.highlight == '2R' ||
                    risk.highlight == '3R'
                  "
                  class="highlight"
                >
                  <div class="pop-up risk flex-mid">
                    <el-tooltip placement="top">
                      <div slot="content" class="fw-400 fs-11">
                        {{ risk.highlightContent }}
                      </div>
                      <div
                        class="fw-700 fs-12 fc-FFFFFF center cursor-pointer"
                        style="padding-top: 3px; width: 14px"
                      >
                        {{
                          risk.highlight == "R"
                            ? "!"
                            : risk.highlight == "2R"
                            ? "!!"
                            : "!!!"
                        }}
                      </div>
                    </el-tooltip>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="relative last">
          <div class="right label fw-700 fs-10">
            <div style="width: 80px">{{ $t("commponents.MOST_RECENT") }}</div>
          </div>
        </div>
      </div>
      <div v-else class="risk-container flex-mid">
        <div class="fs-14 fw-06 flex-mid opa-05" style="height: 92px">
          No recent data
        </div>
      </div>
    </div>

    <div
      
      v-if="userDetail.medal && Object.keys(userDetail.medal).length"
      class="max-width-mobile mx-auto fc-000000"
    >
      <div class="fs-14 fw-700 ml-18">Medals</div>
      
        <div class="medals-container flex-center disable-scrollbar cursor-grab"
        style="display: -webkit-box;"
          v-dragscroll
          >
          <div
            class="mx-5"
            :key="index"
            v-for="(name, index) in userDetail.medal"
          >
            <div v-if="name.image&&name" style="display: flex;justify-items: center;flex-direction: column; align-items: center;">
              <img :src="getImgUrlSetNew(name.image)" class="img-medal" />
              <p class="fw-700 fc-FBC02D fs-10 m-0 ellipsis" >{{ name.en }}</p>
            </div>
            <div v-else>
              <img :src="getImgUrlSet(`${index}-on@3x`)" class="img-medal" />
              <p class="fw-700 fc-FBC02D fs-10 m-0 ellipsis">{{ index }}</p>
            </div>
          </div>
        </div>
      
    </div>

    <div
      v-if="
        modalMemberData['leaderboard'] && modalMemberData['leaderboard'].length
      "
      class="fc-000000"
    >
      <div class="max-width-mobile mx-auto">
        <div class="fs-14 fw-700 ml-18">Leaderboards</div>
      </div>
      <div
        v-dragscroll
        class="leaderboards-container disable-scrollbar mt-12 pb-8 cursor-grab"
      >
        <div
          class="flex-center"
          style="width: fit-content; padding-left: 120px"
        >
          <div
            v-for="(valueLeader, index) in modalMemberData['leaderboard']"
            :key="valueLeader.id + '_' + index"
            class="box-content"
            :class="valueLeader.id"
          >
            <div class="icons-header">
              <img
                :src="$utils('icons', retrunImage(valueLeader.id))"
                :alt="valueLeader.key"
                style="width: 20px; height: 20px"
              />
            </div>
            <div class="fs-16 fw-700 mt-5">
              {{ valueLeader.value }}
            </div>
            <div class="fs-12 mt-7" style="font-family: Georgia">
              {{ setOrdinalSuffix(valueLeader.rank_month) }} /
              {{ setOrdinalSuffix(valueLeader.rank_all) }}
            </div>
            <div class="fs-11 opa-05 mt-2">{{ valueLeader.key }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="
        modalMemberData['topskill'] && modalMemberData['topskill'].length > 0
      "
      class="max-width-mobile mx-auto fc-000000"
    >
      <div class="mx-18 mt-16">
        <div class="flex mb-12">
          <div class="fs-14 fw-700">Top Skills</div>
          <div class="fs-12 opa-04 ml-12 mt-2">
            unique peer feedback endorsements
          </div>
        </div>
        <div
          v-for="(data, index) in modalMemberData['topskill']"
          :key="index + data.key + '_skill_'"
        >
          <div
            v-if="showMoreTopSkill ? true : index < 5"
            class="skill-status-container"
          >
            <div class="label ellipsis">{{ data.key }}</div>
            <div v-if="data.value < 13" class="status-image flex-center">
              <div
                v-for="(num, index2) in data.value"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'skill_on')"
                  alt="skill_on"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div
                v-for="(num, index2) in data.value != 12 ? 12 - data.value : 0"
                :key="num + '_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'skill_off')"
                  alt="skill_off"
                  style="width: 13px; height: 13px"
                />
              </div>
            </div>
            <div v-else class="status-image flex-center">
              <div
                v-for="(num, index2) in 10"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'skill_on')"
                  alt="skill_on"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div class="icons-text top-skill mx-auto">
                +{{ data.value - 10 }}
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="!showMoreTopSkill && modalMemberData['topskill'].length > 5"
          class="mb-26"
        >
          <span @click="showMoreTopSkill = true" class="view-all"
            >View all</span
          >
        </div>
      </div>
    </div>
    <div
      v-if="
        modalMemberData['cultureAdd'] &&
        modalMemberData['cultureAdd'].length > 0
      "
      class="max-width-mobile mx-auto fc-000000"
    >
      <div class="mx-18 mt-24">
        <div class="flex mb-12">
          <div class="fs-14 fw-700">Culture Add</div>
          <div class="fs-12 opa-04 ml-12 mt-2">
            contributions to recognition #values
          </div>
        </div>





      <div>
        
        <div
          v-dragscroll
          id="riskBox"
          class="flex-center disable-scrollbar cursor-grab"
          style="display: -webkit-box;  height: 40px;"
        >
          <div
            v-for="(value) in recognitionValue"
            :key="value.value + '_input'"
          >
          <div style=" height: 27px;">
            <span @click="setRecognition(value.label)"  :class="setClassRecognition(value.label)?'reconigtion-tags-selected center fs-13':'reconigtion-tags center fs-13'" >{{ value.label}} ({{ hashtag[value.label]}})</span>
          </div>
          </div>
        </div>
       
      </div>
      

       
    
        <div
          v-for="(data, index) in modalMemberData['cultureAdd']"
          :key="index + data.key + '_skill_'"
        >
        <div v-if="selectRecognition==data.key">
          <div
            v-if="showMoreCultureAdd ? true : index < 5"
            class="skill-status-container"
          >
            <div class="label ellipsis">{{ data.key }}</div>
            <div v-if="data.value < 13" class="status-image flex-center">
              <div
                v-for="(num, index2) in data.value"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_14dp')"
                  alt="add_purple_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div
                v-for="(num, index2) in data.value != 12 ? 12 - data.value : 0"
                :key="num + '_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_10_14dp')"
                  alt="add_purple_10_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
            </div>
            <div v-else class="status-image flex-center">
              <div
                v-for="(num, index2) in 10"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_14dp')"
                  alt="add_purple_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div class="icons-text culture-add mx-auto">
                +{{ data.value - 10 }}
              </div>
            </div>
          </div>
        </div>
        <div v-if="selectRecognition=='All'">
          <div
            v-if="showMoreCultureAdd ? true : index < 5"
            class="skill-status-container"
          >
            <div class="label ellipsis">{{ data.key }}</div>
            <div v-if="data.value < 13" class="status-image flex-center">
              <div
                v-for="(num, index2) in data.value"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_14dp')"
                  alt="add_purple_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div
                v-for="(num, index2) in data.value != 12 ? 12 - data.value : 0"
                :key="num + '_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_10_14dp')"
                  alt="add_purple_10_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
            </div>
            <div v-else class="status-image flex-center">
              <div
                v-for="(num, index2) in 10"
                :key="num + '_skill_' + index2"
                class="flex-mid"
              >
                <img
                  :src="$utils('icons', 'add_purple_14dp')"
                  alt="add_purple_14dp"
                  style="width: 13px; height: 13px"
                />
              </div>
              <div class="icons-text culture-add mx-auto">
                +{{ data.value - 10 }}
              </div>
            </div>
          </div>
        </div>
        </div>


        <div class="recognition flex-center" style=" height: 56px; border-radius: 4px;" >
          <template >
                      <div class="flex-between "  style=" width:296px;">
                          <div
                            :class="`color-bar`"
                            :style="`width: ${setBarWidthRecognition(recognition.orderGiven,recognition.count_given_all)}px;`"
                          ></div>
                          <div class="flex-center ml-12" style="position: relative;">
                           
                          <div class="ranking">
                              <span class="label fs-11 flex-mid" style="width: 32px">{{
                              recognition.orderGiven
                              }}</span>
                          </div>
                          <div class="flex-column ml-12">
                            <span class="txtName ellipsis fs-13 fw-700  opa-1" style="color: #5F32A7;">
                              {{ "Recognition Given"}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000">{{
                              "Alignment Rating Score" }}</span>
                          </div>
                          </div>
                          <div class="flex-column mr-10" style="position: relative;">
                            <span class="txtName ellipsis fs-13 fw-700 opa-1 right" style="color: #5F32A7;">
                              {{ recognition.given}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 right"> {{ recognition.alignmentGiven}}</span>
                          </div>
                       
                      </div>
          </template>

        </div>

        
        <div class="recognition flex-center" style=" height: 56px; margin-top: 12px; border-radius: 4px;">
          <template >
                      <div class="flex-between "  style=" width:296px;">
                        <div
                            :class="`color-bar`"
                            :style="`width: ${setBarWidthRecognition(recognition.orderReceived,recognition.count_received_all)}px;`"
                          ></div>
                          <div class="flex-center ml-12" style="position: relative;">
                           
                          <div class="ranking">
                              <span class="label fs-11 flex-mid fs-11" style="width: 32px">{{
                              recognition.orderReceived
                              }}</span>
                          </div>
                          <div class="flex-column ml-12">
                            <span class="txtName ellipsis fs-13 fw-700  opa-1" style="color: #5F32A7;">
                              {{ "Recognition Received"}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 ">{{
                              "Alignment Rating Score" }}</span>
                          </div>
                          </div>
                          <div class="flex-column mr-10" style="position: relative;">
                            <span class="txtName ellipsis fs-13 fw-700 opa-1 right" style="color: #5F32A7;">
                              {{ recognition.received}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 right">{{
                              recognition.alignmentReceived }}</span>
                          </div>
                      </div>
                  </template>

        </div>

        
        <div class="recognition flex-center" style=" height: 56px; margin-top: 12px; border-radius: 4px;">
          <template >
                      <div class="flex-between "  style=" width:296px;">
                          <div
                            :class="`color-bar`"
                            :style="`width: ${setBarWidthRecognition(recognition.orderRatio,recognition.count_ratio_all)}px;`"
                          ></div>
                          <div class="flex-center ml-12" style="position: relative;">
                          <div class="ranking">
                              <span class="label fs-11 flex-mid" style="width: 32px">{{
                               recognition.orderRatio
                              }}</span>
                          </div>
                          <div class="flex-column ml-12" >
                            <span class="txtName ellipsis fs-13 fw-700  opa-1" style="color: #5F32A7;">
                              {{ "Give-to-receive Ratio"}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 ">{{
                              "Alignment Rating Score" }}</span>
                          </div>
                          </div>
                          <div class="flex-column mr-10" style="position: relative;">
                            <span class="txtName ellipsis fs-13 fw-700 opa-1 right" style="color: #5F32A7;">
                              {{ recognition.ratio}}
                              </span>
                              <span class="txtTeam ellipsis fs-11 fw-400 opa-08 fc-000000 right">{{
                              recognition.alignmentRatio }}</span>
                          </div>
                      </div>
                  </template>

        </div>


        <div
          v-if="!showMoreCultureAdd && modalMemberData['cultureAdd'].length > 5"
          class="mb-26"
        >
          <span @click="showMoreCultureAdd = true" class="view-all"
            >View all</span
          >
        </div>
        <div class="fs-12 pt-8" style="color: #5f32a7"
        :class="[ blurMode ?  'blurelement': '' ]">
          {{ userDetail.firstname }} is a top
          {{ userDetail.culture_add_percentile }}% culture add contributor
        </div>
      </div>
    </div>

    <div
      class="flex-mid tabs-112"
      style="padding-top: 8px; padding-bottom: 32px"
    >
      <el-tabs id="tabHeaderStyle" v-model="activeTab">
        <el-tab-pane label="powers" name="powers" default>
          <span slot="label" class="tabsTitle">{{
            $t("commponents.power")
          }}</span>
          <div>
            <div
              v-for="data in powerData"
              :key="data.label + '_bar'"
              class="power-tabs flex-center"
              :class="`power-${data.icon}`"
            >
              <div class="rating-box flex-mid">
                <span class="px-4">{{ data.rating !== undefined ? data.rating : '-' }}</span>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  id="star_black_24dp"
                  width="16"
                  height="16"
                  viewBox="0 0 16 16"
                  class="pb-2"
                >
                  <g id="Group_13402" data-name="Group 13402">
                    <path
                      id="Path_5306"
                      data-name="Path 5306"
                      d="M0,0H16V16H0Z"
                      fill="none"
                    />
                    <path
                      id="Path_5307"
                      data-name="Path 5307"
                      d="M0,0H16V16H0Z"
                      fill="none"
                    />
                  </g>
                  <g
                    id="Group_13403"
                    data-name="Group 13403"
                    transform="translate(2.295 2.382)"
                    :fill="matchingColorWidthName(data.icon)"
                  >
                    <path
                      id="Path_5308"
                      data-name="Path 5308"
                      d="M9.148,12.7l2.767,1.673a.665.665,0,0,0,.993-.72l-.733-3.147,2.447-2.12a.665.665,0,0,0-.38-1.167l-3.22-.273L9.761,3.978a.667.667,0,0,0-1.227,0L7.274,6.944l-3.22.273a.665.665,0,0,0-.38,1.167L6.121,10.5l-.733,3.147a.665.665,0,0,0,.993.72Z"
                      transform="translate(-3.443 -3.573)"
                    />
                  </g>
                </svg>
              </div>
              <div
                :class="`color-bar`"
                :style="`width: ${setBarWidth(data.value, data.maxValue)}px;`"
              ></div>
              <div class="icon-container">
                <img
                  class="icon absolute-mid"
                  :src="getImgIconOfPower(data.icon)"
                  :alt="data.icon"
                />
                <!-- <div class="text-value absolute-mid">
                  <span>{{
                    $utils("powerBreakingPoint", data.value).label
                  }}</span
                  ><span class="fs-11">{{
                    $utils("powerBreakingPoint", data.value).unit
                  }}</span>
                </div> -->
              </div>
              <div class="relative">{{ data.label }}</div>
              <div class="ml-auto mr-16 relative">
                {{ $utils("addCommasInNumber", data.value || 0) }}
              </div>
            </div>
          </div>
        </el-tab-pane>
        <!-- <el-tab-pane label="badges" name="Badges">
          <span slot="label" class="tabsTitle">{{ $t('commponents.badges') }}</span>
          <div
            v-if="userDetail.status !== 'new'"
            class="divContentProfileModal"
          >
            <div
              v-if="!modalMemberData['achievements']"
              class="center pt-40 mt-40"
            >
              <loading-even></loading-even>
            </div>
            <div
              class="rowDataSkillStyle"
              :key="index"
              v-for="(item, index) in modalMemberData['achievements']"
            >
              <div style="padding-left: 20px; width: 65%">
                <span class="fc-4A4A4A fs-16">{{ item.name }}</span>
              </div>
              <div style="display: flex; padding-right: 20px; width: 35%">
                <div v-for="i in 6" :key="item.name + '_' + i">
                  <div v-if="i <= item.count" class="curcleUnlock"></div>
                  <div v-else class="curcleLock"></div>
                </div>
              </div>
            </div>
          </div>
          <div v-else>
            <div
              v-if="userDetail.status !== 'new'"
              class="divContentProfileModal"
            >
              <div
                class="rowDataSkillStyle"
                :key="index"
                v-for="(item, index) in modalMemberData['achievements']"
              >
                <div style="padding-left: 20px; width: 65%">
                  <span class="fc-4A4A4A fs-16">{{ item.name }}</span>
                </div>
                <div style="display: flex; padding-right: 20px; width: 35%">
                  <div v-for="i in 6" :key="item.name + '_' + i">
                    <div v-if="i <= item.count" class="curcleUnlock"></div>
                    <div v-else class="curcleLock"></div>
                  </div>
                </div>
              </div>
            </div>
            <div v-else class="divContentProfileModal">
              <div
                v-for="text in [
                  'Initiative',
                  'Contributor',
                  'Leadership',
                  'Health',
                ]"
                :key="text"
                class="rowDataSkillStyle"
              >
                <div style="padding-left: 20px; width: 65%">
                  <span class="fc-4A4A4A fs-16">{{ text }}</span>
                </div>
                <div style="display: flex; padding-right: 20px; width: 35%">
                  <div
                    v-for="index in [1, 2, 3, 4, 5, 6]"
                    :key="index"
                    class="curcleLock"
                  ></div>
                </div>
              </div>
            </div>
          </div>
        </el-tab-pane> -->
        <el-tab-pane label="Org" name="org">
          <span slot="label" class="tabsTitle">{{
            $t("commponents.org")
          }}</span>
          <org-tab v-if="orgChartData" :orgData="orgChartData" />
        </el-tab-pane>
        <el-tab-pane label="Relationships" name="relationships">
          <span slot="label" class="tabsTitle">{{
            $t("commponents.relationships")
          }}</span>
          <relationship-mapping
            v-if="reladingRelationshipStatus"
            :modalMemberData="modalMemberData"
            :profile="relationshipData"
          />
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import { dragscroll } from "vue-dragscroll";
import { globalfunc } from "../../globalfunc";
export default {
  directives: {
    dragscroll,
  },
  name: "modal-preview-user",
  components: {
    loadingEven: require("@/components/even/loading").default,
    relationshipMapping:
      require("@/components/members/members-components/relationship-mapping")
        .default,
    orgTab: require("@/components/members/members-components/org").default,
  },
  props: [
    "userDetail",
    "passProfileToRelationship",
    "orgChartData",
    "powerData",
    "modalMemberData",
    "relationshipData",
  ],
  data() {
    return {
      orgData: [],
      activeTab: "powers",
      showMoreTopSkill: false,
      showMoreCultureAdd: false,
      reladingRelationshipStatus: true,
      selectRecognition:'All'
    };
  },
  computed: {
    riskData() {
      return this.$store.getters["people/riskData"];
    },
    loadingLoadMoreData() {
      return this.$store.getters["people/loadingLoadMoreData"];
    },
    riskDataMembers() {
      return this.$store.getters["newmember/riskData"];
    },
    loadingLoadMoreDataMembers() {
      return this.$store.getters["newmember/loadingLoadMoreData"];
    },

    recognition(){
        return this.$store.getters["newmember/recognition"];
    },
    alignment(){
        return this.$store.getters["newmember/alignment"];
    },
    hashtag(){
        return this.$store.getters["newmember/hashtag"];
    },
    recognitionValue(){
        return this.$store.getters["newmember/recognitionValue"];
    },
    last_rank_given(){
        return this.$store.getters["newmember/last_rank_given"];
    },
    last_rank_received(){
        return this.$store.getters["newmember/last_rank_received"];
    },
    last_rank_ratio(){
      return this.$store.getters["newmember/last_rank_ratio"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  mounted() {
    this.reladingRelationshipStatus = false;
    setTimeout(() => {
      var container = this.$el.querySelector("#riskBox");
      container.scrollLeft = container.scrollWidth;
      this.reladingRelationshipStatus = true;
    }, 1000);
  },
  methods: {
    setRecognition(value){
        this.selectRecognition=value
        // console.log('value',value)
        this.$store.dispatch("newmember/filtersReconition", value);

        
    },
    setClassRecognition(value){
        if(this.selectRecognition == value){
            return true;
        }else{
            return false;
        }
    },
    setOrdinalSuffix(i) {
      return globalfunc.ordinal_suffix_of(i);
    },
    getImgUrlMem(pic) {
      var images = require.context("@/assets/images/members/", false, /\.png$/);
      return images("./" + pic + ".png");
    },
    getImgIconOfPower(name) {
      return require("@/assets/images/components/profile/" + name + ".png");
    },
    getImgUrlSet(pic) {
      var images = require.context(
        "@/assets/images/settings/",
        false,
        /\.png$/
      );
      return images("./" + pic + ".png");
    },
    getImgUrlSetNew(url) {
      if(url.includes('Charisma')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCharisma-on%403x.png?alt=media&token=e4172468-60cd-4f49-827e-ef090c0c2802"

      }else if(url.includes('Creativity')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FCreativity-on%403x.png?alt=media&token=104dbd9c-d13c-460a-8ac8-fe930391740d"

      }else if(url.includes('Initiative')){
        return 'https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FInitiative-on%403x.png?alt=media&token=702fcdda-4fea-4d1d-a85b-5e1ed5e8f7e7'
      }else if(url.includes('Intelligence')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FIntelligence-on%403x.png?alt=media&token=06327c99-b89b-4d0a-907d-d2d4fab4489d"
        
      }else if(url.includes('Kindness')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FKindness-on%403x.png?alt=media&token=fb934cc6-4437-4cd9-bb65-6688667b72c7"
        
      }else if(url.includes('Strength')){
        return "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fmedal%2FStrength-on%403x.png?alt=media&token=f673ba77-ec00-4fe7-b49d-dbdea2fc19e5"
      }

     
    },
    retrunImage(value) {
      if (value == "recog_count") {
        return "sup_recog_icon@2x";
      } else if (value == "streak_count") {
        return "daily_streak_icon@2x";
      } else if (value == "super_feedback_count") {
        return "sup_feedback_icon@2x";
      } else if (value == "ps_initiative_making") {
        return "initiative_icon@2x";
      } else if (value == "ps_critical_thinking") {
        return "cri_thinking_icon@2x";
      } else if (value == "ps_self_awareness") {
        return "self_awareness_icon@2x";
      } else if (value == "ps_empathy") {
        return "empathy_icon@2x";
      } else if (value == "ps_optimism") {
        return "Optimism_icon@2x";
      } else if (value == "ps_leadership") {
        return "leadership_icon@2x";
      }
      return "";
    },
    loadMoreData() {
      if (
        this.modalMemberData["from"] &&
        this.modalMemberData["from"] == "members"
      ) {
        this.$store.dispatch("newmember/getDailyStatus", this.userDetail);
      } else {
        this.$store.dispatch("people/getDailyStatus", this.userDetail);
      }
    },
    setBarWidth(value, max) {
      let percentage = (value / max) * 100;
      let width = ((337 - 70) / 100) * percentage;
      return width || "0";
    },
    setBarWidthRecognition(value, max) {
      const _val=value.slice(0,(value.length-2))
      let percentage = ( max - ( parseInt(_val) - 1)) / (max)
      let width =((296) * percentage)
      return width || "0";
    },
    matchingColorWidthName(icon) {
      if (!icon) return "";
      const array = [
        {
          icon: "ic_empathy",
          color: "#6000da",
        },
        {
          icon: "ic_selfawareness",
          color: "#f77511",
        },
        {
          icon: "ic_criticalthinking",
          color: "#ff2b19",
        },
        {
          icon: "ic_leadership",
          color: "#00AA1A",
        },
        {
          icon: "ic_initiative",
          color: "#8CE100",
        },
        {
          icon: "ic_optimism",
          color: "#F2D222",
        },
      ];
      const color = array.find((item) => item.icon === icon);
      return color ? color.color : "";
    },
  },
};
</script>

<style lang="scss" scoped>
.house-seal-image {
  margin: 0px;
  margin-left: 45px;
  width: 90px;
}
.houseSeal_1,
.nullprofileName,
.nullprofileTeamName {
  background-color: #d8d8d8;
}
.houseSeal_1 {
  margin: 0px;
  margin-left: 45px;
  width: 90px;
  height: 110px;
}
.houseSeal_2 {
  margin: 0px;
  margin-left: 45px;
  width: 0;
  height: 0;
  border-left: 45px solid transparent;
  border-right: 45px solid transparent;
  border-top: 45px solid #d8d8d8;
}
.nullprofileName {
  width: 166px;
  height: 25px;
}
.txtProfileName {
  height: 25px;
  font-size: 22px;
  color: #2d2e36;
}
.nullprofileTeamName {
  width: 214px;
  height: 25px;
}
.txtProfileTeamName {
  height: 25px;
  font-size: 16px;
  color: #2d2e36;
  text-transform: uppercase;
}
.img-medal {
  display: block;
  margin: auto;
  width: 42px;
  height: 60px;
}
.curcleUnlock {
  width: 10px;
  height: 10px;
  background: #fbc02d;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  margin-left: 14px;
}
.curcleLock {
  width: 10px;
  height: 10px;
  background: #e9e9e9;
  border: 1px solid #b0b0b0;
  border-radius: 4px;
  margin-left: 14px;
}
.rowDataSkillStyle {
  display: flex;
  align-items: center;
  flex-direction: row;
  height: 52px;
  opacity: 1;
  background-color: #e9e9e9;
  margin-top: 8px;
}
.flex-column {
  word-break: normal;
}
.icon-close {
  position: absolute;
  right: 60px;
  top: 30px;
  font-size: 30px;
  opacity: 0.8;
  cursor: pointer;
  > i {
    position: fixed;
  }
}
.risk-container {
  background-color: rgba($color: #5f32a7, $alpha: 0.04);
  padding: 2px 16px;
  border-radius: 6px;
  margin: 6px 40px;
  .back-button {
    width: 32px;
    height: 32px;
    border-radius: 32px;
    background-color: rgba($color: #000000, $alpha: 0.1);
    margin-right: 6px;
  }
  .risk-line-breaking {
    width: 0px;
    border: 1px solid #a7a7a7;
    border-width: 0 1px 0 0;
    margin: 0 6px 0 12px;
  }
  .risk-status {
    width: 12px;
    height: 12px;
    border-radius: 12px;
    background-color: #00000030;
    margin-left: 6px;
    margin-top: 8px;
  }
  .risk-status.none {
    width: 0px;
    height: 0px;
  }
  .risk-status.gray {
    background-color: #00000030;
  }
  .risk-status.green {
    background-color: #66bb6a;
  }
  .risk-status.yellow {
    background-color: #fbc02d;
  }
  .risk-status.red {
    background-color: #f44336;
  }
  .risk-status.holiday {
    background-color: #dbdbdb;
  }
  .relative.last {
    .label {
      position: absolute;
      right: 0px;
      top: 18px;
      color: rgba($color: #000000, $alpha: 0.5);
    }
  }
  .relative > .highlight {
    position: absolute;
    bottom: 14px;
    width: 80px;
    height: 20px;
    left: -10px;
    .pop-up {
      background-color: #6c30cc;
      border-radius: 12px;
      width: 20px;
      height: 20px;
      position: relative;
      &::after {
        position: absolute;
        top: 16px;
        content: "";
        border: 8px solid #6c30cc;
        border-color: #6c30cc transparent transparent transparent;
      }
    }
    .pop-up.risk {
      background-color: #b40303;
      &::after {
        border: 8px solid #b40303;
        border-color: #b40303 transparent transparent transparent;
      }
    }
    .pop-up-red {
      position: absolute;
      background-color: #b40303;
      border-radius: 12px;
      color: #fff;
      padding: 4px 6px 0 0;
      height: calc(20px - 4px);
    }
    .red-1 {
      width: calc(34px - 6px);
    }
    .red-2 {
      width: calc(37px - 6px);
    }
    .red-3 {
      width: calc(40px - 6px);
    }
  }
}
.risk-box-grab {
  height: 92px;
  width: 450px;
}

.max-width-mobile {
  width: 340px;
  margin: auto;
}

.about-me-container {
  border-radius: 0.6rem;
  padding: 12px 16px;
  background-color: rgba($color: #5f32a7, $alpha: 0.04);
  margin: 12px 0;
}

.medals-container {
  border-radius: 0.6rem;
  border: 4px solid #fbb42d;
  background-color: rgba($color: #6c30cc, $alpha: 1);
  margin: 12px 0;
  height: 78px;
  display: flex;
  width: 100%;
  align-items: flex-start;
  justify-content: center;
}

.leaderboards-container {
  width: 100%;
  .box-content {
    border-radius: 4px;
    box-shadow: 0px 3px 6px #00000029;
    width: calc(100px - 18px);
    height: calc(114px - 24px);
    margin-right: 8px;
    padding: 12px 6px 12px 12px;
    background-color: rgba($color: #ccc, $alpha: 0.2);
    .icons-header {
      background-color: rgba($color: #ccc, $alpha: 1);
      padding: 4px;
      width: 20px;
      height: 20px;
      border-radius: 4px;
    }
  }
  .box-content.recog_count {
    background-color: rgba(102, 187, 106, 0.2);
    .icons-header {
      background-color: rgba(102, 187, 106, 1);
    }
  }
  .box-content.streak_count {
    background-color: rgba(255, 111, 145, 0.2);
    .icons-header {
      background-color: rgba(255, 111, 145, 1);
    }
  }
  .box-content.super_feedback_count {
    background-color: rgba(0, 172, 193, 0.2);
    .icons-header {
      background-color: rgba(0, 172, 193, 1);
    }
  }
  .box-content.ps_initiative_making {
    background-color: rgba(140, 225, 0, 0.2);
    .icons-header {
      background-color: rgba(140, 225, 0, 1);
    }
  }
  .box-content.ps_critical_thinking {
    background-color: rgba(255, 43, 25, 0.2);
    .icons-header {
      background-color: rgba(255, 43, 25, 1);
    }
  }
  .box-content.ps_self_awareness {
    background-color: rgba(247, 117, 17, 0.2);
    .icons-header {
      background-color: rgba(247, 117, 17, 1);
    }
  }
  .box-content.ps_empathy {
    background-color: rgba(96, 0, 218, 0.2);
    .icons-header {
      background-color: rgba(96, 0, 218, 1);
    }
  }
  .box-content.ps_optimism {
    background-color: rgba(242, 210, 34, 0.2);
    .icons-header {
      background-color: rgba(242, 210, 34, 1);
    }
  }
  .box-content.ps_leadership {
    background-color: rgba(0, 170, 26, 0.2);
    .icons-header {
      background-color: rgba(0, 170, 26, 1);
    }
  }
}
.skill-status-container {
  display: grid;
  grid-template-columns: 106px auto;
  margin-bottom: 16px;
  margin-top: 8px;
  gap: 10px;
  .label {
    font-size: 13px;
  }
  .status-image {
    display: grid;
    grid-template-columns: repeat(12, 8.33%);
  }
  .icons-text {
    color: #fff;
    font-size: 10px;
    font-weight: 900;
    min-width: 18px;
    padding: 1px 4px;
    grid-column: span 2;
    text-align: center;
  }
  .icons-text.top-skill {
    background-color: #00acc1;
    border-radius: 7px;
  }
  .icons-text.culture-add {
    background-color: #5f32a7;
    border-radius: 2px;
  }
}
.ranking {
  background: #FFFFFF;
  border-radius: 50%;
}
.ranking .label {
  line-height: 32px;
  color: #000000;
  font-weight: 500;
}
.view-all {
  cursor: pointer;
  color: #0097a7;
  font-size: 13px;
  font-weight: 500;
}
.divCoin {
  padding-top: 65px;
  padding-right: 30px;
}
.iconCoin {
  width: 32px;
  height: 32px;
  margin-right: 6px;
}
.txtCoin {
  padding-left: 6px;
}
.reconigtion-tags-selected {
  font-size: 13px;
  font-weight: 700;
  border:1px solid #00ACC1;
  background-color: #32C2D5;
  border-radius: 21px;
  color: #FFFFFF;
  margin-right: 6px;
  padding: 6px 12px 6px 12px;
  transition: 0.2s;
  border-radius: 21px;
  cursor: default;
}
.reconigtion-tags {
  font-size: 13px;
  font-weight: 400;
  background-color: #FFFFFF;
  border: 1px solid #000000;
  color: #000000;
  margin-right: 6px;
  padding: 6px 12px 6px 12px;
  transition: 0.2s;
  border-radius: 20px;
  cursor: pointer;
  &:hover {
    border:1px solid #00ACC1;
    color: #00ACC1;
    opacity: 1;
  }
}
</style>

<style lang="scss">
#userPreviewDetails {
  .el-tabs__item.is-active,
  .el-tabs__item {
    font-size: 16px;
    color: rgba($color: #000000, $alpha: 0.72);
    height: 44px;
  }
  .el-tabs__item.is-active {
    color: rgba($color: #000000, $alpha: 1);
    font-weight: 900;
  }
  .el-tabs__active-bar {
    background-color: #13debf !important;
  }
}

</style>
